import { LocalStorageManager } from 'services/storage/LocalStorageManager';

export function getLastSelectedTemplateId(projectId: string): string {
  return LocalStorageManager.getLastViewedTemplateId(projectId);
}

export function setLastSelectedTemplateId(
  projectId: string,
  value: string
): void {
  LocalStorageManager.setLastViewedTemplateId(projectId, value);
}
